import { type GetCurrentUserQuery } from "~/graphql/mainTypes";
import { type GetComplianceCaseQuery } from "~/graphql/supergraphTypes";
import { toDbId } from "~/utils/graphql-helpers";

const ACTIVE_ASSIGNEE_STATUSES = [
  "in_progress",
  "under_review",
  "escalated",
  "pending_fund_review",
  "pending_data_resubmission",
] as const;

export const getAssigneeRole = (
  complianceCaseData: GetComplianceCaseQuery | undefined,
  userData: GetCurrentUserQuery | undefined,
): "maker" | "checker" | undefined => {
  const complianceCase = complianceCaseData?.complianceCase;
  const makerId = complianceCase?.maker?.externalUser?.objectId;
  const checkerId = complianceCase?.checker?.externalUser?.objectId;
  const assigneeId = complianceCase?.assignee?.externalUser?.objectId;
  const userId = toDbId(userData?.currentUser?.id || "").toString();

  if (
    assigneeId === userId &&
    ACTIVE_ASSIGNEE_STATUSES.includes(
      (complianceCase?.status || "") as (typeof ACTIVE_ASSIGNEE_STATUSES)[number],
    )
  ) {
    if (makerId === userId) return "maker";
    if (checkerId === userId) return "checker";
  }

  return undefined;
};
